import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'NumberOrdinal',

    propTypes: {
        value: PropTypes.number.isRequired,
        upperCase: PropTypes.bool,
    },

    render() {
        let toUpper = this.props.upperCase === 'undefined' ? false : this.props.upperCase;

        if (this.props.value) {
            let valueWithOrdinal = numeral(this.props.value).format('0o');
            let value = valueWithOrdinal.substring(0, valueWithOrdinal.length - 2);

            // numeral returns 0th if it can't parse value
            if (value !== '0') {
                let valueOrdinal = valueWithOrdinal.substring(valueWithOrdinal.length - 2);

                if (toUpper) {
                    valueOrdinal = valueOrdinal.toUpperCase();
                }

                return (
                    <span className="number-with-ordinal" key="ordinal">
                        <span key="value"> {value} </span>
                        <sup key="ordinal"> {valueOrdinal} </sup>
                    </span>
                );
            }
        }

        return <span></span>;
    },
});
